export default __webpack_public_path__ + "static/media/5eb87e8260af96d0db375b5a251ca238.png";